import React from 'react'
import { ReactComponent as Loader } from '../Assets/loader.svg'

const Button = ({ onSubmit, text, loading = false, disabled, classCss }) => {
  return (
    <button className={classCss + ' submit-btn'} onClick={onSubmit} disabled={disabled} data-content={text}>
      {!loading ? text : <Loader className="spinner" />}
    </button>
  )
}

export default Button
